import { render, staticRenderFns } from "./MedOcuFisico.vue?vue&type=template&id=727ecc82&scoped=true"
import script from "./MedOcuFisico.vue?vue&type=script&lang=js"
export * from "./MedOcuFisico.vue?vue&type=script&lang=js"
import style0 from "./MedOcuFisico.vue?vue&type=style&index=0&id=727ecc82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727ecc82",
  null
  
)

export default component.exports